import { Button, Modal } from 'antd'
import Icon from '@forwardflow/ui/Icons'
import { useEmailVerificationModalStore } from '@forwardflow/store/modal/emailVerificationModal'
import { UserService } from '@forwardflow/services/UserService'
export const EmailVerificationModal: React.FC = () => {
   const { isOpen, name, icon, iconClassName, closeEmailVerificationModal } =
      useEmailVerificationModalStore()

   const handleDisableModal = async () => {
      try {
         await UserService.updateFirstSignIn(false)
         closeEmailVerificationModal()
      } catch {
         console.error('Unable to call updateFirstSignIn api')
      }
   }

   return (
      <Modal
         className="p-0 ff-modal"
         open={isOpen}
         title=""
         closeIcon={false}
         footer={null}
      >
         <div className="flex flex-col">
            <div className="w-[100px] h-[100px] rounded-full bg-primary/40 flexc mx-auto mt-[50px] mb-10">
               <Icon name={icon} className={iconClassName} />
            </div>
            <div className="text-[24px] font-medium text-center">
               Welcome to Forward Flow,
            </div>
            <p className="mb-2 text-[24px] font-semibold text-center">{name}</p>
            <div className="flex justify-center">
               <hr className="w-1/2 border-t-2 border-[#b4b4b4] opacity-80 my-4" />
            </div>
            <p className="px-20 mt-6 text-center mb-14">
               You're all set. Forward Flow will work now behind the scenes to
               turn your leads into real appointments without the stress.
            </p>
         </div>
         <div className="flex justify-center mb-6">
            <Button
               onClick={handleDisableModal}
               className="w-full h-12 font-semibold transition-all duration-300 rounded !bg-[#9061DA]/60 hover:!bg-[#9061DA]/90 hover:shadow-lg !text-white hover:!text-white border-0 mb-4 mx-8 hover:scale-105"
            >
               Explore Forward Flow
            </Button>
         </div>
      </Modal>
   )
}
